import { Edit as RaEdit, useGetIdentity } from "react-admin";
import React, { Fragment } from "react";

import Form from "./Form";
import HelpBlock from "../component/HelpBlock";
import Title from "../component/Title";

const Edit = (props) => {
  const { identity } = useGetIdentity();
  return (
    <Fragment>
      <HelpBlock
        {...props}
        form
        visible={
          identity?.permissions &&
          identity?.permissions.indexOf("executive-projects") === -1
        }
        visibleFor={["researcher"]}
        context="edit"
      />
      <RaEdit
        {...props}
        title={<Title source="user.name" resource="user-outputs" />}
      >
        <Form />
      </RaEdit>
    </Fragment>
  );
};
export default Edit;
